import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import AssistantWidget from "@/components/AssistantWidget";
import Dashboard from "@/pages/Dashboard";
import SKUs from "@/pages/SKUs";
import BOMs from "@/pages/BOMs";
import Production from "@/pages/Production";
import Adjustments from "@/pages/Adjustments";
import Receipts from "@/pages/Receipts";
import Orders from "@/pages/Orders";
import Facilities from "@/pages/Facilities";
import Manage from "@/pages/Manage";
import ItemDetail from "@/pages/ItemDetail";
import FacilityDetail from "@/pages/FacilityDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/skus" element={<SKUs />} />
            <Route path="/skus/:code" element={<ItemDetail />} />
            <Route path="/boms" element={<BOMs />} />
            <Route path="/production" element={<Production />} />
            <Route path="/adjustments" element={<Adjustments />} />
            <Route path="/receipts" element={<Receipts />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/facilities" element={<Facilities />} />
            <Route path="/facilities/:id" element={<FacilityDetail />} />
            <Route path="/manage" element={<Manage />} />
          </Routes>
        </Layout>
        <AssistantWidget />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
